<template>
  <transition
  tag="div"
  appear
  name="from-right-to-left"
  mode="out-in">
    <FilesDashboardRecent
    v-if="showRecent"/>
    <FilesDashboardRoot
    v-else/>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

import FilesDashboardRecent from '@/components/files/dashboard/recent/FilesDashboardRecent'
import FilesDashboardRoot from '@/components/files/dashboard/root/FilesDashboardRoot'

export default {
  name: 'FilesDashboardMain',

  components: {
    FilesDashboardRecent,
    FilesDashboardRoot
  },

  computed: {
    ...mapGetters('filesRecent', [
      'showRecent'
    ])
  }
}
</script>
